import React from 'react';
import { useMemo } from 'react';
import { Redirect, useParams } from 'react-router-dom';

import { decodeUrlName, SiteConfigManager, useCategoryState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

const { SPORT_PREMATCH } = COMPONENT_TYPES;

const TournamentRedirect = ({ children }) => {
  const { initialized, loading, tournaments } = useCategoryState();
  const { tournamentName } = useParams();

  const prematchPath = SiteConfigManager.getExtraConfig(`pathList.${SPORT_PREMATCH}`);

  const tournamentsUrls = useMemo(() => {
    if (!tournaments) return [];
    return tournaments.map(({ urlName }) => decodeUrlName(urlName));
  }, [tournaments]);

  if (!initialized || loading) {
    return null;
  }

  if (!tournamentsUrls.includes(decodeUrlName(tournamentName))) {
    return <Redirect to={prematchPath} />;
  }

  return children;
};

export default TournamentRedirect;
